module.exports = __webpack_public_path__ + "media/images/logo-compleet-small-fb9af817dbd8005ae6735e84a0ef1e4f.svg";